export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-8">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-label font-semibold mb-4 whitespace-nowrap">
              联系我们
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
              投稿与合作咨询
            </h2>
            <p className="text-sm text-foreground-500">
              欢迎优质内容创作者与我们取得联系
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="p-5 rounded-xl bg-background-100 border border-background-200/60 text-center hover:border-primary-200 transition-colors cursor-pointer">
              <span className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-lg bg-primary-100">
                <i className="ri-mail-line text-primary-600 text-lg"></i>
              </span>
              <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-1">邮件投稿</h3>
              <p className="text-xs text-foreground-500">content@91freevideo.com</p>
            </div>
            <div className="p-5 rounded-xl bg-background-100 border border-background-200/60 text-center hover:border-accent-200 transition-colors cursor-pointer">
              <span className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-lg bg-accent-100">
                <i className="ri-discuss-line text-accent-600 text-lg"></i>
              </span>
              <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">biz@91freevideo.com</p>
            </div>
            <div className="p-5 rounded-xl bg-background-100 border border-background-200/60 text-center hover:border-primary-200 transition-colors cursor-pointer">
              <span className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-lg bg-primary-100">
                <i className="ri-question-answer-line text-primary-600 text-lg"></i>
              </span>
              <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-1">意见反馈</h3>
              <p className="text-xs text-foreground-500">feedback@91freevideo.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}